<template>
  <div class="lesson-audios d-flex flex-column">
    <div v-for="(audio, index) in audios" class="mb-2" :key="index">
      <iframe
        class="w-100 border-0"
        :src="src(audio)"
        :height="iframeHeight(audio)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    audios: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    src(audio) {
      if (audio.link.indexOf("player") > 0) {
        return audio.link;
      }
      return `https://w.soundcloud.com/player/?url=${audio.link}`;
    },
    iframeHeight(audio) {
      if (audio.link.indexOf("playlists") > 0) {
        return 450;
      }
      return 170;
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-audios {
}
</style>
